import { Download } from "lucide-react";
import { FileField } from "../../../ui/index.ts";
import { DOCUMENTS, W9_DOWNLOAD_URL, type DocumentId } from "./consultant-us.config.ts";
import styles from "./consultant-us.module.css";

export type ConsultantDocuments = Partial<Record<DocumentId, File>>;

export function ConsultantUsDocuments({ files, onChange }: {
  files: ConsultantDocuments;
  onChange: (id: DocumentId, file: File | null) => void;
}) {
  return (
    <div className={styles.stack}>
      <p className={styles.lead}>Please attach the following documents, as applicable.</p>
      <div className={styles.downloadPanel}>
        <div>
          <p className={styles.lead}>Download the form, complete and sign it, then attach your completed copy below.</p>
       
        </div>
        <a className={styles.downloadButton} href={W9_DOWNLOAD_URL} download>
          <Download size={17} aria-hidden />Download W-9 Form
        </a>
      </div>
      {DOCUMENTS.map(({ id, label, hint }) => (
        <FileField
          key={id}
          id={`consultant-us-document-${id}`}
          label={label}
          required={id === "tax"}
          hint={hint}
          stagedFile={files[id] ?? null}
          onChange={(file) => onChange(id, file)}
        />
      ))}
    </div>
  );
}
